//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  LinearProgress,
} from '@mui/material';

// === HOOKS ===
import { useTaskComplete } from 'components/useTaskComplete';


//#endregion

//-----------------------------------------------------------------
export function ProgressBar() {
  //-----------------------------------------------------------------

  //#region [VALUES]
  
  const theme    = useTheme();
  const progress = useTaskComplete();

  //#endregion

  //#region [STYLES]

  const _styles = {
    task_progress: {
      height: '12px',
    }
  }

  const TASK_PROGRESS = {
    sx      : _styles.task_progress,
    color   : 'success',
    variant : 'determinate',
    value   : progress.percent,
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return <LinearProgress { ...TASK_PROGRESS } />
  }

  //#endregion

  return display();
}